import { render, staticRenderFns } from "./Inpatient.vue?vue&type=template&id=42e53186&scoped=true"
import script from "./Inpatient.vue?vue&type=script&lang=js"
export * from "./Inpatient.vue?vue&type=script&lang=js"
import style0 from "./Inpatient.vue?vue&type=style&index=0&id=42e53186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e53186",
  null
  
)

export default component.exports